/* eslint-disable max-len */
import React from 'react';
function Learning() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12,3L1,9l4,2.2v6l7,3.8l7-3.8v-6l2-1.1V17h2V9L12,3z M18.8,9L12,12.7L5.2,9L12,5.3L18.8,9z M17,16l-5,2.7L7,16v-3.7l5,2.7 l5-2.7C17,12.3,17,16,17,16z" })));
}
export default Learning;
